import { makeStyles, Theme } from "@material-ui/core";
import {
  borderRadius,
  borderStyle,
  centerItemFlex,
  getCurrentAccentTextColor,
  getRelativeFontSize,
  mediumFont,
} from "../../../utils/styles";

const quantitySelectorStyles = makeStyles(
  (theme: Theme) => ({
    selectorContainer: {
      padding: "10px 12px",
      border: borderStyle,
      borderRadius: borderRadius,
      "& > div": {
        ...centerItemFlex,
      },
    },
    numText: {
      ...mediumFont,
      fontSize: getRelativeFontSize(4),
    },
    cursor: {
      cursor: "pointer",
    },
    opacity: {
      opacity: 0.7,
    },
    accentColorBorder: {
      border: "1px solid " + getCurrentAccentTextColor(),
    },
  }),
  { index: 1 }
);

export default quantitySelectorStyles;
